module.exports = __webpack_public_path__ + "media/assets/images/landings/kitchen/mano_sporca-77dfb2ab260344150186bd74e59286c3.jpg";